import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { useCart } from '../../context/CartContext';
import ProductImageGallery from '../../components/ProductImageGallery';

const Switch2WristStrip = () => {
  const { addToCart } = useCart();
  const [selectedImage, setSelectedImage] = useState(0);
  const [quantity, setQuantity] = useState(1);
  const [selectedColor, setSelectedColor] = useState('orange-blue');
  const [activeTab, setActiveTab] = useState('overview');
  const [selectedAddOns, setSelectedAddOns] = useState([]);

  // 产品图片
  const productImages = [
    '/images/shop-products/switch-wrist-strip/switch-2-joycon-strap.jpg',
    '/images/shop-products/switch-wrist-strip/Screenshot 2025-05-27 010019.png',
    '/images/shop-products/switch-wrist-strip/Screenshot 2025-05-27 010028.png',
    '/images/shop-products/switch-wrist-strip/Screenshot 2025-05-27 010033.png'
  ];

  // 产品信息
  const product = {
    id: 4,
    name: "Switch 2 Wrist Strap – Motion Sensor Hand Band for Fitness Boxing & Just Dance",
    price: "S$8.90",
    originalPrice: "S$15.90",
    description: "Motion sensor hand band designed for fitness boxing and Just Dance with enhanced grip and motion tracking",
    specs: {
      "Material": "TPE Rubber + Copper Core",
      "Size": "Adjustable",
      "Color Options": "Blue-Orange",
      "Pack": "1 Pair",
      "Weight": "~80g",
      "Compatibility": "Nintendo Switch 2 Controllers",
      "Grip Type": "Adjustable Strap",
      "Washable": "Yes",
      "Breathability": "Skin-friendly",
      "Durability": "High Strength",
      "Installation": "Easy Plug & Play",
      "Maintenance": "Wipe Clean",
      "Warranty": "–",
      "Certification": "–",
      "Storage": "Dry & Cool Place",
      "Care Instructions": "Hand Wash, Air Dry"
    },
    features: [
      "Motion Sensor Technology",
      "Fitness Boxing Compatible",
      "Just Dance Ready",
      "Adjustable Strap Design",
      "Skin-friendly Material",
      "Easy Installation"
    ],
    colors: ['orange-blue'],
    inStock: true,
    rating: 4.3,
    reviews: 423
  };

  const handleAddToCart = () => {
    const selectedAddOnItems = addOnProducts.filter(addOn => selectedAddOns.includes(addOn.id));
    addToCart({
      ...product,
      quantity,
      selectedColor,
      image: productImages[0],
      selectedAddOns: selectedAddOnItems
    });
  };

  const toggleAddOn = (addOnId) => {
    setSelectedAddOns(prev => 
      prev.includes(addOnId) 
        ? prev.filter(id => id !== addOnId)
        : [...prev, addOnId]
    );
  };

  const colorOptions = {
    'orange-blue': { name: 'Blue-Orange', class: 'bg-gradient-to-r from-orange-500 to-blue-600' }
  };

  // Add-on 产品
  const addOnProducts = [
    {
      id: 'ac-adapter',
      name: 'Switch 2 AC Adapter',
      price: 'S$39.99',
      image: '/images/shop-products/switch-ac-adapter/switch 2 ac adapter.jpg',
      description: 'Official Nintendo Switch AC adapter for fast charging'
    },
    {
      id: '4in1-charger',
      name: 'Switch 2 4-in-1 Charger Dock',
      price: 'S$19.90',
      image: '/images/shop-products/switch-charger-dock/switch 2  4 in 1 controlller charger dock.jpg',
      description: 'Dual charging dock for Switch and Joy-Cons with LED indicators'
    },
    {
      id: 'screen-protector',
      name: 'Switch 2 Screen Protector',
      price: 'S$12.99',
      image: '/images/shop-products/switch-protect-screen/switch 2 protecter screen.jpg',
      description: 'High-quality tempered glass screen protector for Switch 2'
    }
  ];

  return (
    <div className="min-h-screen bg-dark-400 text-white">
      {/* 顶部导航栏 */}
      <div className="bg-dark-500 border-b border-gray-700">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16">
            <div className="flex items-center">
              <h1 className="text-2xl font-bold text-white">CHILL GAMING</h1>
            </div>
            <div className="flex items-center space-x-6">
              <a href="/" className="text-gray-300 hover:text-white transition-colors">Home</a>
              <a href="/shop" className="text-gray-300 hover:text-white transition-colors">Shop</a>
              <a href="/cart" className="text-gray-300 hover:text-white transition-colors">Cart</a>
              <a href="/support" className="text-gray-300 hover:text-white transition-colors">Support</a>
              <button className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg transition-colors">
                Shop Now
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {/* 面包屑导航 */}
        <nav className="flex items-center space-x-2 text-sm text-gray-400 mb-8">
          <a href="/" className="hover:text-white transition-colors">Home</a>
          <span>/</span>
          <a href="/shop" className="hover:text-white transition-colors">Shop</a>
          <span>/</span>
          <a href="/shop/nintendo-switch" className="hover:text-white transition-colors">Nintendo Switch</a>
          <span>/</span>
          <span className="text-white">Switch 2 Wrist Strap</span>
        </nav>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          {/* 产品图片 */}
          <div className="space-y-4">
            <ProductImageGallery 
              images={productImages}
              currentImage={productImages[selectedImage]}
              onImageChange={(image) => {
                const index = productImages.findIndex(img => img === image);
                setSelectedImage(index);
              }}
            />
          </div>

          {/* 产品信息 */}
          <div className="space-y-6">
            <div>
              <h1 className="text-3xl font-bold text-white mb-2">
                {product.name}
              </h1>
              <div className="flex items-center space-x-4 mb-4">
                <div className="flex items-center">
                  {[...Array(5)].map((_, i) => (
                    <svg
                      key={i}
                      className={`w-5 h-5 ${
                        i < Math.floor(product.rating)
                          ? 'text-yellow-400'
                          : 'text-gray-600'
                      }`}
                      fill="currentColor"
                      viewBox="0 0 20 20"
                    >
                      <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                    </svg>
                  ))}
                  <span className="ml-2 text-sm text-gray-400">
                    {product.rating} ({product.reviews} reviews)
                  </span>
                </div>
              </div>
            </div>

            {/* 价格 */}
            <div className="flex items-center space-x-4 mb-4">
              <span className="text-3xl font-bold text-white">
                {product.price}
              </span>
              <span className="text-xl text-gray-400 line-through">
                {product.originalPrice}
              </span>
              <div className="bg-red-600 text-white px-3 py-1 rounded-md text-sm font-bold">
                44% OFF
              </div>
            </div>

            {/* 产品描述 */}
            <p className="text-gray-300 text-lg leading-relaxed">
              {product.description}
            </p>

            {/* 颜色选择 */}
            <div className="mb-6">
              <h3 className="text-lg font-semibold mb-3 text-white">Choose Colour</h3>
              <div className="flex space-x-4">
                {product.colors.map((color) => (
                  <div key={color} className="flex flex-col items-center">
                    <button
                      onClick={() => setSelectedColor(color)}
                      className={`w-20 h-20 rounded-lg border-2 overflow-hidden ${
                        selectedColor === color
                          ? 'border-white ring-2 ring-white ring-opacity-50'
                          : 'border-gray-600'
                      } transition-all hover:scale-105 shadow-lg`}
                      title={colorOptions[color].name}
                    >
                      <img 
                        src="/images/shop-products/switch-wrist-strip/Screenshot 2025-05-27 010019.png" 
                        alt={colorOptions[color].name}
                        className="w-full h-full object-cover"
                      />
                    </button>
                    <span className="text-sm text-white mt-2 font-medium">
                      {colorOptions[color].name}
                    </span>
                  </div>
                ))}
              </div>
            </div>

            {/* Add-on 选择 */}
            <div className="mb-6">
              <h3 className="text-lg font-semibold mb-3 text-white">Add on</h3>
              <div className="grid grid-cols-1 gap-3">
                {addOnProducts.map((addOn) => (
                  <div 
                    key={addOn.id}
                    onClick={() => toggleAddOn(addOn.id)}
                    className={`flex items-center p-3 rounded-lg border-2 cursor-pointer transition-all ${
                      selectedAddOns.includes(addOn.id)
                        ? 'border-green-500 bg-green-500 bg-opacity-10'
                        : 'border-gray-600 hover:border-gray-500'
                    }`}
                  >
                    <div className="w-12 h-12 rounded-lg overflow-hidden mr-3 flex-shrink-0">
                      <img 
                        src={addOn.image} 
                        alt={addOn.name}
                        className="w-full h-full object-cover"
                      />
                    </div>
                    <div className="flex-1">
                      <h4 className="text-white font-medium text-sm">{addOn.name}</h4>
                      <p className="text-gray-400 text-xs">{addOn.description}</p>
                    </div>
                    <div className="flex items-center space-x-2">
                      <span className="text-green-400 font-bold text-sm">+{addOn.price}</span>
                      <div className={`w-5 h-5 rounded border-2 flex items-center justify-center ${
                        selectedAddOns.includes(addOn.id)
                          ? 'border-green-500 bg-green-500'
                          : 'border-gray-500'
                      }`}>
                        {selectedAddOns.includes(addOn.id) && (
                          <svg className="w-3 h-3 text-white" fill="currentColor" viewBox="0 0 20 20">
                            <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                          </svg>
                        )}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* 数量选择 */}
            <div className="mb-6">
              <h3 className="text-lg font-semibold mb-3 text-white">Quantity</h3>
              <div className="flex items-center border border-gray-500 rounded-lg overflow-hidden w-fit">
                <button
                  onClick={() => setQuantity(Math.max(1, quantity - 1))}
                  className="w-12 h-12 bg-gray-800 hover:bg-gray-700 flex items-center justify-center transition-colors text-white text-xl font-bold border-r border-gray-500"
                >
                  -
                </button>
                <div className="w-16 h-12 bg-gray-800 flex items-center justify-center border-r border-gray-500">
                  <span className="text-xl font-semibold text-white">
                    {quantity}
                  </span>
                </div>
                <button
                  onClick={() => setQuantity(quantity + 1)}
                  className="w-12 h-12 bg-gray-800 hover:bg-gray-700 flex items-center justify-center transition-colors text-white text-xl font-bold"
                >
                  +
                </button>
              </div>
            </div>

            {/* 库存状态 */}
            <div className="flex items-center space-x-2 mb-6">
              <div className="w-3 h-3 bg-green-500 rounded-full"></div>
              <span className="text-green-400 font-medium">In Stock</span>
            </div>

            {/* 购买按钮组 */}
            <div className="space-y-3 mb-6">
              {/* Add to Cart 按钮 */}
              <motion.button
                whileHover={{ scale: 1.02 }}
                whileTap={{ scale: 0.98 }}
                onClick={handleAddToCart}
                className="w-full bg-green-600 hover:bg-green-700 text-white font-bold py-4 px-8 rounded-lg transition-all duration-300 shadow-lg hover:shadow-xl"
              >
                Add to Cart - {product.price}
              </motion.button>

              {/* Buy Now 按钮 */}
              <motion.button
                whileHover={{ scale: 1.02 }}
                whileTap={{ scale: 0.98 }}
                onClick={() => {
                  handleAddToCart();
                  // 这里可以添加跳转到结账页面的逻辑
                  window.location.href = '/checkout';
                }}
                className="w-full bg-gray-700 hover:bg-gray-600 text-white font-bold py-4 px-8 rounded-lg transition-all duration-300 shadow-lg hover:shadow-xl"
              >
                Buy Now
              </motion.button>
            </div>

            {/* 配送信息 */}
            <div className="border-t border-gray-700 pt-6">
              <div className="flex items-center mb-3">
                <svg className="w-5 h-5 mr-2 text-gray-400" fill="currentColor" viewBox="0 0 20 20">
                  <path d="M8 16.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zM15 16.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0z" />
                  <path d="M3 4a1 1 0 00-1 1v10a1 1 0 001 1h1.05a2.5 2.5 0 014.9 0H10a1 1 0 001-1v-5h2a1 1 0 00.9-.5l1.5-2A1 1 0 0015 7h-3V4a1 1 0 00-1-1H3zM14 7l-1.5 2H10V5h4v2z" />
                </svg>
                <span className="text-gray-300">Free Meet Up (Available at Sengkang & Orchard locations)</span>
              </div>
              <div className="flex items-center">
                <svg className="w-5 h-5 mr-2 text-gray-400" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z" clipRule="evenodd" />
                </svg>
                <span className="text-gray-300">Available Shipping</span>
              </div>
            </div>
          </div>
        </div>

        {/* 标签页导航 */}
        <div className="mt-16">
          <div className="border-b border-gray-700">
            <nav className="flex space-x-8">
              <button 
                onClick={() => setActiveTab('overview')}
                className={`py-4 px-1 border-b-2 font-medium transition-colors ${
                  activeTab === 'overview'
                    ? 'border-green-500 text-green-400'
                    : 'border-transparent text-gray-400 hover:text-white'
                }`}
              >
                Overview
              </button>
              <button 
                onClick={() => setActiveTab('specifications')}
                className={`py-4 px-1 border-b-2 font-medium transition-colors ${
                  activeTab === 'specifications'
                    ? 'border-green-500 text-green-400'
                    : 'border-transparent text-gray-400 hover:text-white'
                }`}
              >
                Specifications
              </button>
              <button 
                onClick={() => setActiveTab('reviews')}
                className={`py-4 px-1 border-b-2 font-medium transition-colors ${
                  activeTab === 'reviews'
                    ? 'border-green-500 text-green-400'
                    : 'border-transparent text-gray-400 hover:text-white'
                }`}
              >
                Reviews ({product.reviews})
              </button>
            </nav>
          </div>

          {/* 标签页内容 */}
          <div className="py-8">
            {activeTab === 'overview' && (
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
                <div>
                  <h3 className="text-2xl font-bold mb-6">Product Overview</h3>
                  <div className="space-y-4 text-gray-300 leading-relaxed">
                    <p>
                      The Switch 2 Joycon Strap combines comfort and functionality for extended gaming sessions. 
                      Designed specifically for Nintendo Switch controllers, these straps provide the perfect balance 
                      of support and flexibility.
                    </p>
                    <p>
                      Made from premium neoprene material, the straps feature adjustable sizing to fit various hand sizes. 
                      The breathable fabric ensures comfort during long gaming sessions, while the non-slip grip 
                      prevents accidental drops.
                    </p>
                    <p>
                      Perfect for bedroom gaming, living room sessions, or any environment where you need reliable 
                      controller support. The silent operation won't disturb others, and the lightweight design 
                      ensures you can game for hours without fatigue.
                    </p>
                  </div>
                </div>
                <div>
                  <h3 className="text-2xl font-bold mb-6">Key Features</h3>
                  <div className="space-y-4">
                    {[
                      {
                        title: "Adjustable Fit",
                        description: "Customizable sizing ensures perfect fit for all hand sizes and gaming styles"
                      },
                      {
                        title: "Sweat Absorbent",
                        description: "Premium neoprene material wicks away moisture for comfortable extended use"
                      },
                      {
                        title: "Non-Slip Grip",
                        description: "Enhanced grip technology prevents accidental controller drops during intense gaming"
                      },
                      {
                        title: "Lightweight Design",
                        description: "Ultra-light construction reduces hand fatigue during long gaming sessions"
                      }
                    ].map((feature, index) => (
                      <div key={index} className="flex items-start space-x-3">
                        <div className="w-6 h-6 bg-green-500 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                          <svg className="w-4 h-4 text-white" fill="currentColor" viewBox="0 0 20 20">
                            <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                          </svg>
                        </div>
                        <div>
                          <h4 className="font-semibold text-white mb-1">{feature.title}</h4>
                          <p className="text-gray-300 text-sm">{feature.description}</p>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            )}

            {activeTab === 'specifications' && (
              <div>
                <h3 className="text-2xl font-bold text-white mb-8">Technical Specifications</h3>
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-0">
                  {Object.entries(product.specs).map(([key, value], index) => (
                    <div key={key} className={`flex justify-between items-center py-4 px-2 ${index < Object.entries(product.specs).length - 1 ? 'border-b border-gray-700' : ''}`}>
                      <span className="text-gray-300 font-medium text-sm uppercase tracking-wide">{key}:</span>
                      <span className="text-white font-semibold text-right max-w-xs">{value}</span>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {activeTab === 'reviews' && (
              <div>
                <h3 className="text-2xl font-bold mb-8">Customer Reviews</h3>
                <div className="space-y-6">
                  <div className="bg-gray-800 p-6 rounded-lg">
                    <div className="flex items-center space-x-4 mb-4">
                      <div className="w-10 h-10 bg-gray-600 rounded-full flex items-center justify-center">
                        <span className="text-white font-semibold">J</span>
                      </div>
                      <div>
                        <h4 className="font-semibold text-white">John D.</h4>
                        <div className="flex items-center space-x-1">
                          {[...Array(5)].map((_, i) => (
                            <svg key={i} className="w-4 h-4 text-yellow-400" fill="currentColor" viewBox="0 0 20 20">
                              <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                            </svg>
                          ))}
                        </div>
                      </div>
                    </div>
                    <p className="text-gray-300">
                      "These straps are incredibly comfortable! No more hand fatigue during long gaming sessions. Great quality and definitely worth recommending."
                    </p>
                  </div>
                  <div className="bg-gray-800 p-6 rounded-lg">
                    <div className="flex items-center space-x-4 mb-4">
                      <div className="w-10 h-10 bg-gray-600 rounded-full flex items-center justify-center">
                        <span className="text-white font-semibold">M</span>
                      </div>
                      <div>
                        <h4 className="font-semibold text-white">Mike S.</h4>
                        <div className="flex items-center space-x-1">
                          {[...Array(4)].map((_, i) => (
                            <svg key={i} className="w-4 h-4 text-yellow-400" fill="currentColor" viewBox="0 0 20 20">
                              <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                            </svg>
                          ))}
                          <svg className="w-4 h-4 text-gray-600" fill="currentColor" viewBox="0 0 20 20">
                            <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                          </svg>
                        </div>
                      </div>
                    </div>
                    <p className="text-gray-300">
                      "Excellent non-slip grip! My controllers never slip out of my hands anymore. Great color options too!"
                    </p>
                  </div>
                  <div className="bg-gray-800 p-6 rounded-lg">
                    <div className="flex items-center space-x-4 mb-4">
                      <div className="w-10 h-10 bg-gray-600 rounded-full flex items-center justify-center">
                        <span className="text-white font-semibold">S</span>
                      </div>
                      <div>
                        <h4 className="font-semibold text-white">Sarah L.</h4>
                        <div className="flex items-center space-x-1">
                          {[...Array(5)].map((_, i) => (
                            <svg key={i} className="w-4 h-4 text-yellow-400" fill="currentColor" viewBox="0 0 20 20">
                              <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                            </svg>
                          ))}
                        </div>
                      </div>
                    </div>
                    <p className="text-gray-300">
                      "Perfect fit and very easy to install. The material feels premium and the adjustable sizing works great for different hand sizes."
                    </p>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Switch2WristStrip;